import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const manuales = [
  { tipo: "Balcón básico", precio: "350 - 500 €", emoji: "🏠" },
  { tipo: "Terraza media (3x2m)", precio: "600 - 900 €", emoji: "🌅" },
  { tipo: "Terraza grande (4x3m)", precio: "900 - 1.300 €", emoji: "🏖️" },
];

const motorizados = [
  { tipo: "Balcón", precio: "500 - 700 €", emoji: "🏠" },
  { tipo: "Terraza media", precio: "1.000 - 1.500 €", emoji: "🌅" },
  { tipo: "Terraza grande", precio: "1.500 - 2.500 €", emoji: "🏖️" },
];

const cofres = [
  { tipo: "Semi-cofre", precio: "900 - 1.500 €", emoji: "📦" },
  { tipo: "Cofre completo", precio: "1.200 - 2.000 €", emoji: "📦" },
  { tipo: "Cofre extra premium", precio: "1.800 - 2.500 €", emoji: "⭐" },
];

const verandas = [
  { tipo: "Pérgola simple manual", precio: "2.500 - 4.000 €", emoji: "🏗️" },
  { tipo: "Bioclimática", precio: "4.000 - 8.000 €", emoji: "⚡" },
  { tipo: "Glass curtain", precio: "6.000 - 12.000 €", emoji: "🏨" },
];

const factores = [
  { icon: "ri-fullscreen-line", title: "Tamaño (m²)", desc: "El precio se calcula por metro cuadrado. Una terraza de 3x2m (6m²) no cuesta lo mismo que una de 5x3m (15m²). A mayor superficie, mejor relación precio/m²." },
  { icon: "ri-palette-line", title: "Tipo de lona", desc: "Lona acrílica estándar: precio base. Microperforada o técnica premium (Tempotest, Sauleda): +20-40%. Mayor durabilidad y anti-UV para el sol de Málaga." },
  { icon: "ri-flashlight-line", title: "Motorización + sensores", desc: "Motor Somfy estándar: +150-250€. Con sensor de viento: +80-150€. Con sensor de sol: +80-150€. Con app TaHoma: +200-300€. Control por voz: compatible." },
  { icon: "ri-hammer-line", title: "Estructura", desc: "Aluminio lacado estándar: precio base. Aluminio anti-salitre reforzado para costa: +10-15%. Acero galvanizado para pérgolas: coste según cálculo estructural." },
  { icon: "ri-building-line", title: "Anclajes especiales", desc: "Fachada estándar (ladrillo/hormigón): incluido. Fachada especial (piedra, madera, aislante): +50-150€. Alturas elevadas que requieren plataforma: +80-200€." },
];

const incluye = [
  "Visita y medición GRATIS",
  "Diseño + presupuesto detallado",
  "Fabricación a medida exacta",
  "Instalación profesional",
  "Garantía completa (5 años motor)",
  "Sin costes ocultos",
];

const faqs = [
  {
    q: "¿Aceptáis financiación?",
    a: "Sí, trabajamos con financiación sin intereses hasta 12 meses a través de nuestro partner financiero. Para importes superiores a 1.500€ puedes fraccionar el pago en 3, 6, 12 o 24 meses. Pregúntanos en la visita técnica: te preparamos el estudio sin compromiso.",
  },
  {
    q: "¿Cobráis desplazamiento?",
    a: "No. El desplazamiento dentro de Málaga capital es GRATIS. Para zonas de la Costa del Sol (Marbella, Fuengirola, Estepona, etc.) aplicamos un pequeño suplemento de 20-40€ según distancia, que se desglosa claramente en el presupuesto. La visita técnica es gratis en toda la provincia.",
  },
  {
    q: "¿Dais factura con IVA?",
    a: "Sí, emitimos factura completa con IVA incluido en todos nuestros trabajos. Para instalaciones en viviendas habituales, puedes beneficiarte de deducciones fiscales en tu IRPF por reformas de mejora energética (hasta un 20% en determinados supuestos). Te informamos al detalle.",
  },
  {
    q: "¿Aceptáis Bizum y tarjeta?",
    a: "Sí, aceptamos pago en efectivo, transferencia bancaria, tarjeta de crédito/débito (incluida American Express) y Bizum. Para financiación sin intereses, usamos tarjeta bancaria. El pago se divide normalmente: 30% al aceptar presupuesto y 70% al finalizar instalación.",
  },
  {
    q: "¿Hacéis descuentos por comunidades de vecinos?",
    a: "Sí. Si tu comunidad de vecinos necesita instalar o reparar varios toldos a la vez, aplicamos descuentos por volumen: 2 toldos -5%, 3-5 toldos -10%, 6+ toldos -15%. También ofrecemos mantenimiento anual programado para comunidades a precio reducido.",
  },
];

export default function PreciosToldos() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Precios Toldos Málaga 2026 | Tarifas Detalladas"
        description="Precios toldos en Málaga 2026: balcón 350-700€, motorizado 600-2200€, pérgola 2500-8000€. Sin sorpresas."
        canonical="/toldos/precios-toldos/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Toldos", path: "/toldos" }, { name: "Precios toldos" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Sin costes ocultos
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Precios de Toldos en Málaga 2026
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Tarifas transparentes. Aquí tienes los precios orientativos por tipo de toldo.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Sin costes ocultos</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Factura con IVA</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:-rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80&auto=format&fit=crop"
                    alt="Precios transparentes de toldos en Málaga 2026"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* DISCLAIMER */}
        <section className="bg-primary/5 py-6">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <p className="font-body text-sm text-center text-primary font-medium">
              ⚡ Precios orientativos sujetos a visita técnica. Sin coste de desplazamiento en Málaga capital. Sin compromiso.
            </p>
          </div>
        </section>

        {/* TABLA PRECIOS MANUALES */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-text-primary mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-primary/10 text-primary rounded-xl flex items-center justify-center text-xl">✋</span>
                Toldos Manuales
              </h2>
              <div className="bg-surface-alt rounded-3xl overflow-hidden">
                <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-border bg-primary/5">
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary">Tipo</div>
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary text-right">Precio</div>
                </div>
                {manuales.map((p, i) => (
                  <div key={p.tipo} className={`grid grid-cols-1 sm:grid-cols-2 items-center ${i !== manuales.length - 1 ? "border-b border-border" : ""}`}>
                    <div className="px-6 md:px-8 py-5 font-body text-base text-text-primary flex items-center gap-3">
                      <span>{p.emoji}</span> {p.tipo}
                    </div>
                    <div className="px-6 md:px-8 py-5 font-heading font-bold text-lg text-primary text-right">{p.precio}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* TABLA PRECIOS MOTORIZADOS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-text-primary mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-primary/10 text-primary rounded-xl flex items-center justify-center text-xl">⚡</span>
                Toldos Motorizados
              </h2>
              <div className="bg-white rounded-3xl overflow-hidden shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-border bg-primary/5">
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary">Tipo</div>
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary text-right">Precio</div>
                </div>
                {motorizados.map((p, i) => (
                  <div key={p.tipo} className={`grid grid-cols-1 sm:grid-cols-2 items-center ${i !== motorizados.length - 1 ? "border-b border-border" : ""}`}>
                    <div className="px-6 md:px-8 py-5 font-body text-base text-text-primary flex items-center gap-3">
                      <span>{p.emoji}</span> {p.tipo}
                    </div>
                    <div className="px-6 md:px-8 py-5 font-heading font-bold text-lg text-primary text-right">{p.precio}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* TABLA PRECIOS COFRE */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-text-primary mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-primary/10 text-primary rounded-xl flex items-center justify-center text-xl">📦</span>
                Toldos Cofre
              </h2>
              <div className="bg-surface-alt rounded-3xl overflow-hidden">
                <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-border bg-primary/5">
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary">Tipo</div>
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary text-right">Precio</div>
                </div>
                {cofres.map((p, i) => (
                  <div key={p.tipo} className={`grid grid-cols-1 sm:grid-cols-2 items-center ${i !== cofres.length - 1 ? "border-b border-border" : ""}`}>
                    <div className="px-6 md:px-8 py-5 font-body text-base text-text-primary flex items-center gap-3">
                      <span>{p.emoji}</span> {p.tipo}
                    </div>
                    <div className="px-6 md:px-8 py-5 font-heading font-bold text-lg text-primary text-right">{p.precio}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* TABLA PRECIOS VERANDA */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-text-primary mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-primary/10 text-primary rounded-xl flex items-center justify-center text-xl">🏗️</span>
                Veranda / Pérgola
              </h2>
              <div className="bg-white rounded-3xl overflow-hidden shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-border bg-primary/5">
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary">Tipo</div>
                  <div className="px-6 md:px-8 py-4 font-heading font-bold text-base text-text-primary text-right">Precio</div>
                </div>
                {verandas.map((p, i) => (
                  <div key={p.tipo} className={`grid grid-cols-1 sm:grid-cols-2 items-center ${i !== verandas.length - 1 ? "border-b border-border" : ""}`}>
                    <div className="px-6 md:px-8 py-5 font-body text-base text-text-primary flex items-center gap-3">
                      <span>{p.emoji}</span> {p.tipo}
                    </div>
                    <div className="px-6 md:px-8 py-5 font-heading font-bold text-lg text-primary text-right">{p.precio}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* DISCLAIMER DESTACADO */}
        <section className="bg-primary py-10 md:py-14">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <p className="font-body text-lg text-white font-semibold mb-2">
              ⚡ Precios orientativos sujetos a visita técnica
            </p>
            <p className="font-body text-base text-white/80">
              Sin coste de desplazamiento en Málaga capital. Sin compromiso.
            </p>
          </div>
        </section>

        {/* FACTORES */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Qué afecta al precio?</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              <p className="font-body text-lg text-text-secondary max-w-2xl mx-auto mt-4">
                Cada instalación es única. Estos son los factores que determinan el precio final de tu toldo.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
              {factores.map((f, i) => (
                <motion.div
                  key={f.title}
                  className="bg-surface-alt rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${f.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{f.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{f.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ¿QUÉ INCLUYE? */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
              <div className="w-full lg:w-1/2">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Qué incluye nuestro presupuesto?</h2>
                <div className="w-10 h-1 bg-primary rounded-full mb-6"></div>
                <p className="font-body text-lg text-text-secondary leading-relaxed mb-8">
                  Todo esto está incluido en el precio. No cobramos extra por desplazamiento, mediciones ni conexiones eléctricas básicas.
                </p>
                <div className="flex flex-col gap-3">
                  {incluye.map((item, i) => (
                    <motion.div
                      key={i}
                      className="flex items-center gap-4 bg-white rounded-xl px-5 py-4 shadow-sm"
                      initial={{ opacity: 0, x: -15 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.08 }}
                    >
                      <span className="flex items-center justify-center w-8 h-8 bg-primary/10 text-primary rounded-full shrink-0 font-bold text-sm">✓</span>
                      <span className="font-body text-base text-text-primary">{item}</span>
                    </motion.div>
                  ))}
                </div>
              </div>
              <div className="w-full lg:w-1/2 bg-white rounded-3xl p-8 md:p-10 shadow-sm">
                <h3 className="font-heading font-bold text-2xl text-text-primary mb-4">Comparativa con la competencia</h3>
                <p className="font-body text-base text-text-secondary leading-relaxed mb-6">
                  Nuestros precios son competitivos vs grandes cadenas porque trabajamos directamente con fábrica, sin intermediarios. Te ahorras el margen del distribuidor.
                </p>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <span className="flex items-center justify-center w-6 h-6 bg-primary text-white rounded-full shrink-0 text-xs font-bold mt-0.5">✓</span>
                    <div>
                      <p className="font-body font-semibold text-text-primary text-sm">Fabricación directa</p>
                      <p className="font-body text-xs text-text-secondary">Sin intermediarios ni distribuidores. Precio de fábrica + instalación profesional.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="flex items-center justify-center w-6 h-6 bg-primary text-white rounded-full shrink-0 text-xs font-bold mt-0.5">✓</span>
                    <div>
                      <p className="font-body font-semibold text-text-primary text-sm">Mismo motor Somfy, mejor precio</p>
                      <p className="font-body text-xs text-text-secondary">Instaladores certificados Somfy que compran al por mayor. Mismo motor, precio más bajo.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="flex items-center justify-center w-6 h-6 bg-primary text-white rounded-full shrink-0 text-xs font-bold mt-0.5">✓</span>
                    <div>
                      <p className="font-body font-semibold text-text-primary text-sm">Sin costes ocultos</p>
                      <p className="font-body text-xs text-text-secondary">El presupuesto incluye TODO: visita, medición, anclajes, instalación, pruebas, IVA.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="flex items-center justify-center w-6 h-6 bg-primary text-white rounded-full shrink-0 text-xs font-bold mt-0.5">✓</span>
                    <div>
                      <p className="font-body font-semibold text-text-primary text-sm">Garantía directa</p>
                      <p className="font-body text-xs text-text-secondary">Garantía Somfy oficial 5 años en motor. Garantía propia 2 años en mano de obra.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CÓMO PEDIR PRESUPUESTO */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Cómo pedir tu presupuesto</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <motion.div
                className="bg-surface-alt rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0 }}
              >
                <div className="text-4xl mb-4">📞</div>
                <h3 className="font-heading font-bold text-lg text-text-primary mb-2">Llámanos</h3>
                <p className="font-body text-sm text-text-secondary mb-4">951 12 07 70</p>
                <p className="font-body text-xs text-text-secondary">Atención inmediata. Te damos rango de precio por teléfono.</p>
              </motion.div>
              <motion.div
                className="bg-surface-alt rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <div className="text-4xl mb-4">💬</div>
                <h3 className="font-heading font-bold text-lg text-text-primary mb-2">WhatsApp</h3>
                <p className="font-body text-sm text-text-secondary mb-4">627 21 33 47</p>
                <p className="font-body text-xs text-text-secondary">Envía fotos de tu terraza/balcón y te respondemos con precio orientativo.</p>
              </motion.div>
              <motion.div
                className="bg-surface-alt rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <div className="text-4xl mb-4">📋</div>
                <h3 className="font-heading font-bold text-lg text-text-primary mb-2">Formulario online</h3>
                <p className="font-body text-sm text-text-secondary mb-4">24h respuesta</p>
                <p className="font-body text-xs text-text-secondary">Rellena el formulario y te llamamos con presupuesto detallado.</p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-primary py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4">¿Quieres un presupuesto exacto?</h2>
            <p className="font-body text-lg text-white/90 max-w-xl mx-auto mb-8">
              Visita técnica gratis, medición precisa y presupuesto detallado en 24h. Sin compromiso ni costes ocultos.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:+34951120770"
                className="inline-flex items-center gap-2 bg-white hover:bg-slate-100 text-primary font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
              >
                <span>📞</span> 951 12 07 70
              </a>
              <a
                href="#presupuesto"
                className="inline-flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-primary font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
              >
                Pedir presupuesto online
              </a>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre precios</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}